
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.224 0H1.772C.794 0 0 .775 0 1.73v20.538C0 23.224.794 24 1.772 24h20.452c.979 0 1.778-.776 1.778-1.732V1.73c0-.954-.8-1.729-1.778-1.729z","fill":"#0A66C2"}}),_c('path',{attrs:{"d":"M5.338 3.304a2.065 2.065 0 010 4.129 2.063 2.063 0 010-4.129zm4.013 5.694h2.633c.432 0 .782.35.782.782v.752a.03.03 0 00.058.015c.48-.896 1.638-1.835 3.36-1.835 3.602 0 4.267 2.372 4.267 5.457v4.504a1.778 1.778 0 11-3.556 0V14.88c0-1.328-.026-3.036-1.85-3.036-1.852 0-2.135 1.446-2.135 2.94v3.887a1.78 1.78 0 11-3.559 0V8.998zm-5.793 1.78a1.78 1.78 0 113.56 0v7.893a1.78 1.78 0 01-3.56 0v-7.892z","fill":"#FEFEFE"}})])
          )
        }
      }
    